import * as React from 'react'

import { Flex } from '~ui/components/layout/Box'
import { Text } from '~ui/components/typography/Text/Text'

import { Allergen } from './Allergen'

type TAllergens = RoA<{
  /**
   * allergen id
   */
  id: string
  /**
   * allergen category numerical code
   */
  nameLabel: string
  /**
   * allergen number
   */
  number: number
}>

type TTextProps = Omit<PropsOf<typeof Allergen>, 'number' | 'nameLabel'>

type TProps = NoChildren &
  TTextProps & {
    /**
     * translated label for allergens
     */
    label?: React.ReactNode
    /**
     * array of product's allergens with id, nameLabel (BE code) and allergen number (BE category)
     */
    allergens: TAllergens
  }

/**
 * List of allergens, used on a product.
 *
 * If the `label` prop is `undefined`, the list is wrapped by parentheses.
 */
export const AllergenList: React.FC<TProps> = ({ label, allergens, ...textProps }) => {
  return (
    <Flex justifyContent={`start`} alignItems={`center`} flexWrap={`wrap`}>
      {label && (
        <Text textTransform={`capitalize`} {...textProps}>
          {label}:&nbsp;
        </Text>
      )}

      {!label && <Text {...textProps}>(</Text>}

      {allergens.map(({ id, number, nameLabel }, index) => (
        <React.Fragment key={id}>
          <Allergen
            number={number}
            nameLabel={nameLabel}
            isLastElement={allergens.length - 1 === index}
            {...textProps}
          />
        </React.Fragment>
      ))}

      {!label && <Text {...textProps}>)</Text>}
    </Flex>
  )
}
